const VACATIONS_ABSENCES_ROOT = 'vacations-absences';
const LOANS_ROOT = 'loans';
const FOOD_BENEFIT_ROOT = 'food-benefit';
const SOLIDARITY_ROOT = 'solidarity';

const STATES = {
  MAIN_ROUTING: 'main',
  MAINTENANCE: 'maintenance',
  INDEX: 'index',
  LOGIN: 'login',
  ERROR: 'error',
  AUTHENTICATION: 'authentication',
  NOT_ALLOWED: 'not-allowed',

  VACATIONS_ABSENCES: {
    ROOT: VACATIONS_ABSENCES_ROOT,
    EMPLOYEE_CALENDAR: VACATIONS_ABSENCES_ROOT + '.employee-calendar',
    EMPLOYEE_CALENDAR_MOBILE: VACATIONS_ABSENCES_ROOT + '.employee-calendar-mobile',
    MY_VACATIONS: VACATIONS_ABSENCES_ROOT + '.my-vacations',
    MY_VACATIONS_MOBILE: VACATIONS_ABSENCES_ROOT + '.my-vacations-mobile',
    TEAM_CALENDAR: VACATIONS_ABSENCES_ROOT + '.team-calendar',
    TEAM_CALENDAR_MOBILE: VACATIONS_ABSENCES_ROOT + '.team-calendar-mobile',
    TEAM_REQUESTS: VACATIONS_ABSENCES_ROOT + '.team-requests',
    DELEGATE: VACATIONS_ABSENCES_ROOT + '.delegations',
    PERIOD_LIST_MOBILE: VACATIONS_ABSENCES_ROOT + '.period-list-mobile',
    SCHEDULE_MOBILE: VACATIONS_ABSENCES_ROOT + '.schedule-mobile'
  },

  LOANS: {
    ROOT: LOANS_ROOT,
    CREDITWORTHINESS: LOANS_ROOT + '.my-creditworthiness',
    NEED_A_LOAN: LOANS_ROOT + '.need-a-loan',
    NEED_A_LOAN_RESULTS: LOANS_ROOT + '.results',
    LOANS_CATALOG: LOANS_ROOT + '.loans-catalog',
    MY_LOANS: LOANS_ROOT + '.my-loans',
    WAGE_ADVANCE: LOANS_ROOT + '.wage-advance',
    DETAIL: LOANS_ROOT + '.detail',
    SIGN_UP: LOANS_ROOT + '.sign-up',
    REPAYMENT: LOANS_ROOT + '.repayment',
    CADASTRAL_REFERENCE: LOANS_ROOT + '.cadastral-reference',
    DETAILSADHESION: LOANS_ROOT + '.adhesion'
  },

  FOOD_BENEFIT: {
    ROOT: FOOD_BENEFIT_ROOT,
    MY_FOOD_BENEFIT: FOOD_BENEFIT_ROOT + '.my-food-benefit',
    MANAGER: FOOD_BENEFIT_ROOT + '.food-benefit-manager',
    DELEGATE: FOOD_BENEFIT_ROOT + '.delegations',
    WORK_TEAM: FOOD_BENEFIT_ROOT + '.work-team'
  },

  SOLIDARITY: {
    ROOT: SOLIDARITY_ROOT,
    MY_SOLIDARITY: SOLIDARITY_ROOT + '.my-solidarity',
  },

  SOCIAL_SECURITY: 'social-security',
};

export {
  STATES
};



// WEBPACK FOOTER //
// ./client/app/common/domain/states.js